import { Identifiable, Status } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedAllocation, LinkedPlanzoneResource, LinkedTask } from "./types";

function linkTask(httpClient: HttpClient) {
  return (task: LinkedTask): Promise<LinkedTask> =>
    Promise.all([
      task.status
        ? Promise.resolve(task)
        : httpClient
            .sendHttpRequest<Identifiable<Status>>({
              endpoint: `/tasks/${task.uuid}/status`,
              method: HttpMethods.GET,
            })
            .then((status) => ({
              ...task,
              status,
            })),
      httpClient
        .sendHttpRequest<{
          _embedded: { allocations: Identifiable<LinkedAllocation>[] };
        }>({
          endpoint: `/tasks/${task.uuid}/allocations`,
          method: HttpMethods.GET,
        })
        .then(({ _embedded: { allocations } }) =>
          Promise.all(
            allocations.map((allocation: LinkedAllocation) =>
              httpClient
                .sendHttpRequest<Identifiable<LinkedPlanzoneResource>>({
                  endpoint: allocation._links.resource.href,
                  method: HttpMethods.GET,
                  baseUrl: "",
                })
                .then((resource) => ({
                  ...allocation,
                  resource,
                })),
            ),
          ).then((allocations) => ({
            ...task,
            allocations,
          })),
        ),
    ])
      .then((parts) => parts.reduce((t, part) => ({ ...t, ...part }), task))
      .then((task) => ({
        ...task,
        tags: (Array.isArray(task.tags) ? task.tags : ([] as any)).map(
          // @ts-ignore
          (name) => ({ name }),
        ),
      }));
}

export { linkTask };
